const TOKEN = "token";
const REFRESH_TOKEN = "refresh_token";

export const setAuthorization = (accessToken, refreshToken) => {
    localStorage.setItem(TOKEN, accessToken);
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
}

export const removeAuthorization = () => {
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
}

export const getAuthorization = () => {
    return localStorage.getItem(TOKEN);
}

export const isAuthorization = () => {
    return localStorage.getItem(TOKEN) != null;
}

export const getRefreshToken = () => {
    return localStorage.getItem(REFRESH_TOKEN);
}